import DynamicSelectBoxCategory from "./DynamicSelectBoxCategory";

export default DynamicSelectBoxCategory;
